var _defs, _ellipse, _rect, _ellipse2, _rect2, _ellipse3, _ellipse4, _path, _rect3, _polygon, _path2, _path3, _rect4, _rect5, _rect6, _rect7, _path4, _path5, _path6, _polygon2, _rect8, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect9, _polygon3, _polygon4, _rect10, _rect11, _polygon5, _polygon6, _polygon7, _polygon8, _path14, _path15, _path16, _path17, _rect12, _path18, _path19, _rect13, _rect14, _polygon9, _polygon10, _rect15, _ellipse5, _path20, _path21, _path22, _polygon11, _path23, _path24, _path25, _polygon12, _rect16, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect17, _rect18, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesigner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b82b2812-52d3-4468-9dcb-70dbb603cd17",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.97,
    cy: 658.25,
    rx: 11.86,
    ry: 12.18,
    fill: "#bcbec0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 354.7,
    y: 641.68,
    width: 3.81,
    height: 5.52,
    fill: "#bcbec0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.44,
    cy: 658.25,
    rx: 11.86,
    ry: 12.18,
    fill: "#d1d3d4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170.42,
    y: 641.68,
    width: 3.81,
    height: 5.52,
    fill: "#bcbec0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.69,
    cy: 658.25,
    rx: 11.86,
    ry: 12.18,
    fill: "#bcbec0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.28,
    cy: 657.13,
    rx: 11.86,
    ry: 12.18,
    fill: "#bcbec0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.29,620.2l65.63,21.48s-.74-10,0-10.74-65.47-13-65.47-13Z",
    fill: "#d1d3d4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 259.66,
    y: 529.82,
    width: 9.58,
    height: 30.66,
    fill: "#d1d3d4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "316.66 541.64 311.87 512.26 311.87 512.26 303.09 512.26 274.82 512.26 274.82 497.73 253.43 497.73 253.43 531.26 274.82 531.26 274.82 517.85 302.3 517.85 298.94 541.64 316.66 541.64",
    fill: "#bcbec0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M464.34,641.68c-1.27-17.8-14.42-44.22-20.36-55.33a72.79,72.79,0,0,0-4.88-8c-12.26-17.31-20.59-42.1-23.93-53.23a18.14,18.14,0,0,1,.19-11,166.26,166.26,0,0,0,7.17-34.73l27.32-47S463,449.69,462.7,465.81c0,0,4.91,93.72,11.47,115.85l16.4,73.23Z",
    fill: "#f9b499"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M458.87,430.29s7.92,2.73,9.29,5.74c0,0,6.29,9,7.92,10.38,0,0,4.65,5.46,6.84,26l3.55,45.48L510.24,618l-9.56,6.6-12.3-6.6s-9.29-30.29-15.85-36l-20-140.71Z",
    fill: "#f9b499"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 576.78,
    y: 381.32,
    width: 16.37,
    height: 289.1,
    fill: "#d8d8d8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 697.02,
    y: 381.28,
    width: 16.37,
    height: 289.1,
    fill: "#d8d8d8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 573.35,
    y: 381.32,
    width: 16.37,
    height: 289.1,
    fill: "#ccc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 693.58,
    y: 381.28,
    width: 16.37,
    height: 289.1,
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.26,260.13s-65.62,7.66-57,71.37c0,0-7.19,95.81,85.27,151.38,0,0,73.29,48.38,163.83,3.35,0,0,64.91-27.51,60.6-81.56a64.23,64.23,0,0,0-13.18-33.82C401,350.23,360.06,300.26,322.6,284.7Z",
    fill: "#d1d3d4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74,394.36s-32.19-25.25-50.48-62.86c0,0-14.74-58.89,59.5-71.37L323.49,284.7s37,9.54,97.31,90c0,0,41.55,67.49-50.35,111.56l-49.56-20.6s-55.33-6.7-66.87-15.81C254,449.82,188.49,420.82,170.74,394.36Z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.89,384.91c-42.39,13.42-69.46,64.91-69.46,64.91-40.24-18.81-62.49-35.19-73.32-44.56a53.61,53.61,0,0,1-14-18.82c-16.31-36.89-13.33-84.4-13.33-84.4,4.08-50.3,57.73-61.79,57.73-61.79s22.9-2.31,45.21.82a84.45,84.45,0,0,1,39.92,17c4,3.13,8.89,7.1,14.26,11.9a32.54,32.54,0,0,1,10.31,30.25c-.48,2.51-1,4.85-1.52,6.67",
    fill: "#ff5100",
    "data-primary": "true"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.74 646.07 158.74 636.49 253.75 598.8 275.14 598.8 369.84 635.85 369.84 646.07 277.7 621.64 252.95 621.64 158.74 646.07",
    fill: "#bcbec0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 209.12,
    y: 381.32,
    width: 16.37,
    height: 289.1,
    fill: "#d8d8d8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.41,500.6s27.07-13.33,47.42-65.39c0,0,3.92,5,4.64,6.63a27.17,27.17,0,0,0,9.66-14.45L319.78,384.44s-41,12.45-66.35,65.38c0,0,13.41,9.82,66.59,15.81Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M467.56,640.48s-9.82-8.14-10.06,1.2c0,0-1.2,12.69,0,20.36l69,1.19s2.81-2.32,4-2.55Z",
    fill: "#ff5100",
    "data-primary": "true"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.14,631.14a16.63,16.63,0,0,1,7.9-8.7s1.23-11.18,5.53-8.07l11,6.47s21.08-22.76,25.39-17c0,0,4.79,6.95-4.07,19.64,0,0,24.54,18.76,30,19.48,0,0-44.89-6.54-52.8-8.22C500.13,634.73,482.17,628.74,477.14,631.14Z",
    fill: "#ff5100",
    "data-primary": "true"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M457.5,662s-4.55,5.28,0,8.39h98.68s.72-6.24-5.27-8.39c0,0-8.14,1-20.84-1.44l-3.59,2.63Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M477.14,631.14s-10.08,4.71-4.08,14.93c0,0,1,4.29,15.58,4.14,0,0,18.24,4.24,28.16,6.12,0,0,19.18,8.25,34.11,5.71,0,0,13.61,2.38,18.58-5.83a6.25,6.25,0,0,0-1.2-8c-2.51-2.22-7.23-4.71-15.94-5.35l-52.22-8.14S483.13,628.74,477.14,631.14Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5,330.22l2.23,3.68a7.15,7.15,0,0,1,6.71-4.63l181.55-.1,28.14-19.8a3,3,0,0,0,.73,2l-12.46,9.1,2.4,2.76,12.09-9c1.68,1.91,5.63,1.55,5.63,1.55L595.7,330.3h9.22L592,311.62c1.91-2.15.84-6.33.84-6.33l10.72-7.55a1.78,1.78,0,0,0,.49-2.4h0a1.78,1.78,0,0,0-2.6-.48l-10.17,7.78a6.94,6.94,0,0,0-2-1.82l34.91-24.57-5.75-4.63H385.17l-89.1,63.48,1.68,3.85Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M637.62,307.45h41.51L675.78,297h0a1.92,1.92,0,0,1-1.92-1.91v-1.6h-29.7v1.76a2.23,2.23,0,0,1-2.23,2.23h0Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 663.64,
    y: 291.74,
    width: 5.75,
    height: 2.71,
    fill: "#2c0160",
    "data-secondary": "true"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "642.89 305.95 645.76 344.63 671.79 344.63 674.98 305.95 642.89 305.95",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "672.6 334.84 645.06 335.18 643.68 316.64 674.02 316.64 672.6 334.84",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 698.34,
    y: 340.32,
    width: 35.78,
    height: 4.3,
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 713.87,
    y: 321.42,
    width: 4.28,
    height: 12.15,
    fill: "#ccc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "723.68 311.06 751.47 193.54 755.22 193.54 726.96 315.21 723.68 311.06",
    fill: "#ccc"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "735.82 193.54 740.61 193.54 712.59 311.62 708.75 309.46 735.82 193.54",
    fill: "#ccc"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.78 185.88 601.69 65.16 603.92 61.33 743.16 185.88 736.78 185.88",
    fill: "#ccc"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "610.31 52.07 743.16 172.46 749.87 172.46 610.31 46.96 610.31 52.07",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M495.82,58.21s-1.15,4.37,8.92,10.84c.44.28.86.56,1.27.86,6.3,4.55,59.23,42.59,62.39,37.4C568.4,107.31,540.61,75.7,495.82,58.21Z",
    fill: "#d8d8d8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.63,276.25s-22.69-15.74-40.69,5.05c0,0-7.41,17.92-5,41.95,0,0,12.67,17.83,19.19,21.38h26.52s-5.22-26.34,33-37.05a13.77,13.77,0,0,1-9.62-5.49S210.36,285.19,198.63,276.25Z",
    fill: "#ff5100",
    "data-primary": "true"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.63,276.25s-22.69-15.74-40.69,5.05c0,0-7.41,17.92-5,41.95,0,0,12.67,17.83,19.19,21.38h26.52s-5.22-26.34,33-37.05a13.77,13.77,0,0,1-9.62-5.49S210.36,285.19,198.63,276.25Z",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M243.84,344.63H198.63s-4.79-27.21,33-37.05l43.15,1s41.84-3.91,49.51-8.22c0,0,12.45-12.94,19.4-17.73l5-13.17s11.3-6.47,15.37-12c0,0,3.83,2.4,1.67,7.19,0,0-1.67,3.47-4.43,3.71a13.79,13.79,0,0,0,8.75-4.07,3.5,3.5,0,0,1,2.75-.36l15.07,2.21a.93.93,0,0,1,.67,1.39c-1,1.65-3.34,4.28-8.51,3.26l-5.66.62a6.76,6.76,0,0,0-3.09,1.15L366,276.25l5.45-1.61a4.36,4.36,0,0,1,.94-.19l10.14-.95L301,331.59S263.15,346.25,243.84,344.63Z",
    fill: "#f9b499"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 205.69,
    y: 381.32,
    width: 16.37,
    height: 289.1,
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M209,252.42a15.65,15.65,0,0,1,.33-13.51c1.5-3,4-9.26,7.83-22.25l4.69-14.38s-6.57-7.2,0-12.83c0,0,6.88-4.06,12.2,3.76,0,0,1.25,5,5.32.31A38.4,38.4,0,0,0,244.06,182s11.88-8.45,40-15.95c0,0,7.51,18.76-1.25,37.84,0,0,.26,29.27-17.37,41.51a15.2,15.2,0,0,1-12,2.3,24.3,24.3,0,0,1-9.06-3.77l-.73,9.28a19.16,19.16,0,0,1-2.89,8.84c-3,4.62-8.83,9.09-19.52,2.52C221.23,264.52,212.75,260.53,209,252.42Z",
    fill: "#f9b499"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219,218.85s-22.21-20.64-6.88-57.23c0,0-5.4-9.39.74-14.08,0,0-3.25,4.69,4.26,10a8.14,8.14,0,0,1,1.88-10s1.25,5.63,4.69,5.63c0,0,14.7-10.94,32.84-8.44,0,0,31.59-1.88,26.27-14.7,0,0,25.07,11.57,4.25,46.91l-3-10.94s-27.27,7.68-40,15.95c0,0-5.09,19.31-9.72,12,0,0-3.85-8.09-11.61-4.57A6.3,6.3,0,0,0,219,195c0,3.13,1.72,8,8.84,14.79Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 329.71,
    y: 381.32,
    width: 16.37,
    height: 289.1,
    fill: "#d8d8d8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 326.28,
    y: 381.32,
    width: 16.37,
    height: 289.1,
    fill: "#ccc"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.94 382.77 179.94 370.04 356.85 370.04 729.35 370.04 729.35 382.77 357.14 383.33 179.94 382.77",
    fill: "#d8d8d8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.14 383.33 357.14 370.04 729.35 370.04 729.35 382.77 357.14 383.33",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 253.75,
    y: 558.09,
    width: 21.39,
    height: 40.72,
    fill: "#bcbec0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.16,
    cy: 658.25,
    rx: 11.86,
    ry: 12.18,
    fill: "#d1d3d4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M300,338.64l86.8-62.39H624.2L549,329.17l-179,.1s-7.36-.88-9.28,4.63l-2.23-3.68Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M300,338.64l86.8-62.39H624.2L549,329.17l-179,.1s-7.36-.88-9.28,4.63l-2.23-3.68Z",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M340.53,309.69s-1.39,1.52.76,2.24l-11.13,7.95a1.86,1.86,0,0,0-.43,2.6h0a1.86,1.86,0,0,0,2.6.41l11.32-8.31a9.63,9.63,0,0,0,9.4.09s4.65-1.85,3.46-8.88l10.65-8.1a2.05,2.05,0,0,0,.55-2.87h0a2,2,0,0,0-2.95-.46l-10.25,7.92c.08-.65-.33-1.92-1.74-1.39Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.73 315.06 361.69 335.49 367.44 329.27 354.99 310.11 348.73 315.06",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M367.44,329.27H604.55a7.68,7.68,0,0,1,7.68,7.68h0a7.68,7.68,0,0,1-7.68,7.68H367.44Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M367.44,329.27H604.55a7.68,7.68,0,0,1,7.68,7.68h0a7.68,7.68,0,0,1-7.68,7.68H367.44Z",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M289.6,340.12s-4.31-.81-4.07,4.51h86.22s5.75-2.11,4.07-9.53c0,0-1.19-6.79-8.38-5.83a7.53,7.53,0,0,0-6.71,4.63l-2.23-3.68Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.82 344.63 166.82 370.04 370.93 370.04 746.58 370.04 746.58 344.63 369.09 344.63 166.82 344.63",
    fill: "#ccc"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 369.62,
    y: 344.63,
    width: 376.96,
    height: 25.41,
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M592.83,44.08l-14.69-8.49,6.54-11.15s-3.59-7.9-17-12L548.76,36.9,495.82,58.21s43.35,21.08,72.58,49.1l1-56.76,6.36-10.82,15,9.38Z",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M601.87,67,614.7,45.86a2.47,2.47,0,0,0-2.1-3.75l-23.73,0a2.47,2.47,0,0,0-2.22,3.54l10.88,21.23A2.47,2.47,0,0,0,601.87,67Z",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M601.87,67,614.7,45.86a2.47,2.47,0,0,0-2.1-3.75l-23.73,0a2.47,2.47,0,0,0-2.22,3.54l10.88,21.23A2.47,2.47,0,0,0,601.87,67Z",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M710.37,331.32h12a6,6,0,0,1,6,6v3.05a0,0,0,0,1,0,0H704.42a0,0,0,0,1,0,0v-3.05A6,6,0,0,1,710.37,331.32Z",
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M710,331.32h12a6,6,0,0,1,6,6v3.05a0,0,0,0,1,0,0H704.08a0,0,0,0,1,0,0v-3.05A6,6,0,0,1,710,331.32Z",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M703.8,322.08h24.77a2.46,2.46,0,0,0,2.11-3.74L718.43,298a2.46,2.46,0,0,0-4.17-.07l-12.52,20.32A2.46,2.46,0,0,0,703.8,322.08Z",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M704,322.08h24.77a2.47,2.47,0,0,0,2.11-3.74L718.59,298a2.47,2.47,0,0,0-4.18-.07l-12.52,20.32A2.46,2.46,0,0,0,704,322.08Z",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 734.38,
    y: 170.79,
    width: 25.87,
    height: 25.87,
    rx: 8.21,
    fill: "#ccc"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 734.38,
    y: 170.79,
    width: 25.87,
    height: 25.87,
    rx: 8.21,
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M362.61,268.11,321,246.38l-3-4h5.9l43.75,23.93A9.8,9.8,0,0,1,362.61,268.11Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M370.92,272.87l3.11,1.45,7.89-.75-4.52-2.46S372.52,271.27,370.92,272.87Z",
    fill: "#2c0160",
    "data-secondary": "true"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigner);
export default __webpack_public_path__ + "static/media/Designer.89eebe0046f1b330981d8727687629b8.svg";
export { ForwardRef as ReactComponent };